import { Component, OnInit, Inject } from '@angular/core';
//import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'ms-dialog-custom',
  templateUrl: './dialog-custom.component.html',
  styleUrls: ['./dialog-custom.component.scss']
})
export class DialogCustomComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DialogCustomComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
  }
  ngOnInit() {
  }

  // yes method is used to close the delete dialog and send the response "yes".
  yes() {
    this.dialogRef.close("yes");
  }
  no() {
    this.dialogRef.close("no");
  }
}